import styled from "styled-components";

export const Container = styled.ol`
  padding-left: 0;
  padding-top: var(--spacing-scale-2x);
`;
